module.exports = __webpack_public_path__ + "assets/img/help_image02-1@2x.69b7605c.png";